export default __webpack_public_path__ + "static/media/search.b587ccbc.svg";